import React, { useState } from "react";
import PageLayout from "../../components/PageLayout";
import Salt from "../../components/master/Salt";
import Medicine from "../../components/master/Medicine";

interface MasterPageProps {
    onLogout?: () => void;
    currentPage?: string;
    onNavigate?: (page: string) => void;
}

const MedicineMasterPage: React.FC<MasterPageProps> = ({
    onLogout,
    currentPage,
    onNavigate,
}) => {
    const [activeTab, setActiveTab] = useState<"salts" | "medicines">(
        "salts"
    );

    return (
        <PageLayout onLogout={onLogout} currentPage={currentPage} onNavigate={onNavigate}>
            <div className="p-6">
                {/* Page Header */}
                <div className="mb-6">
                    <h1 className="text-2xl font-bold text-gray-900">
                        Medicine Master
                    </h1>
                    <p className="text-gray-500 text-sm">
                        Manage salt and medicines
                    </p>
                </div>

                {/* Tabs */}
                <div className="flex gap-2 border-b mb-6">
                    <button
                        onClick={() => setActiveTab("salts")}
                        className={`px-4 py-2 text-sm font-medium border-b-2 transition ${activeTab === "salts"
                            ? "border-blue-600 text-blue-600"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Salts
                    </button>

                    <button
                        onClick={() => setActiveTab("medicines")}
                        className={`px-4 py-2 text-sm font-medium border-b-2 transition ${activeTab === "medicines"
                            ? "border-blue-600 text-blue-600"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                            }`}
                    >
                        Medicines
                    </button>
                </div>

                {/* Tab Content */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                    {activeTab === "salts" && <Salt />}
                    {activeTab === "medicines" && <Medicine />}
                </div>
            </div>
        </PageLayout>
    );
};

export default MedicineMasterPage;
